.label {
  font-size: 0.75rem;
  font-family: 'Aeroport';
  font-weight: 500;
  text-transform: uppercase;
  color: var(--grey);
  padding-bottom: 0.5rem;
  letter-spacing: 1.2px;
}

.required {
  padding-left: 0.25rem;
  color: var(--danger-hover);
  font-size: 1rem;
}
